import React, { useContext, useEffect } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes } from "../../../store/storeTypes";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { factory, layoutModelChange, onRenderTabSet } from "./layoutFunctions";
import { spiderData } from "../../../api/s3";
import "../../../layout/layoutstyle.css";

export const HorizonLayout = () => {
  const [store, dispatch] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);
  const { auth, debug } = store;

  if (debug) {
    console.log("HorizonLayout");
  }

  if (lstore) {
    //do nothing
  }

  useEffect(() => {
    let isCancelled = false;
    if (auth) {
      const asyncfunction = async () => {
        const newState = {
          rawdata: [],
        };

        ldispatch({ type: actionTypes.SET_LOADING, payload: true });
        const sdata = await spiderData(auth, grefs.tickerStorage.current);
        if (!isCancelled) {
          if (sdata && sdata.length > 0) {
            sdata.shift(); //romove first row with headers
            newState.rawdata = sdata;
          }
          ldispatch({ type: lactionTypes.SET_HORIZON, payload: newState });
          ldispatch({ type: actionTypes.SET_LOADING, payload: false });
        }
      };
      ///get data from s3
      asyncfunction();
    }
    return () => {
      isCancelled = true;
    };
  }, [auth, ldispatch, dispatch, grefs.tickerStorage]);

  if (layoutState.model ) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={factory}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) => layoutModelChange(model, grefs)}
      />
    );
  } else return null;
};
